<template>
  <v-row dense>
    <v-col>
      <BTextFieldDate
        v-model="form.date_from"
        :close-on-date-select="true"
        validate="required"
        :max="form.date_to"
        :skeleton="skeleton"
        label="Дата с"
        placeholder="Дата больше или равна"
        @input="onInput"
      />
    </v-col>

    <v-col>
      <BTextFieldDate
        v-model="form.date_to"
        :close-on-date-select="true"
        validate="required"
        :min="form.date_from"
        :skeleton="skeleton"
        label="Дата по"
        placeholder="Дата меньше или равна"
        @input="onInput"
      />
    </v-col>
  </v-row>
</template>

<script>
import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'


export default {
  name: 'FormTemplatesFormCellTypeDateInterval',
  components: {
    BTextFieldDate,
  },
  props: {
    skeleton: Boolean,
    value: {
      type: Array,
      required: true,
    },
  },
  data: (vm) => ({
    form: {
      date_from: vm.value[0],
      date_to: vm.value[1],
    },
  }),
  methods: {
    onInput() {
      const f = this.form
      const value = [f.date_from, f.date_to]
      this.$emit('input', value)
    },
  },
}
</script>
